import React, { useMemo } from "react";
import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

/** Instagram / сайт / шоурум — відмінні кольори для кільця */
const COLORS = ["#E4405F", "#0d6efd", "#198754"];

const fmtUa = (v) =>
    Number(Math.round(Number(v) || 0)).toLocaleString("uk-UA", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

/**
 * Кільцева діаграма: частка фактичного ТО з початку місяця до сьогодні по джерелах
 * (сума трьох сегментів = зведення по тих самих замовленнях, що й таблиця).
 */
export default function MonthTurnoverSourceSharePie({ channelRows }) {
    const { chartData, sumTotal } = useMemo(() => {
        if (!Array.isArray(channelRows) || channelRows.length === 0) {
            return { chartData: [], sumTotal: 0 };
        }
        const rows = channelRows.filter((r) => r?.model);
        let sum = 0;
        const base = rows.map((row, i) => {
            const value = Math.max(0, Number(row.model.totalSoFar) || 0);
            sum += value;
            return {
                id: row.key,
                name: `${row.emoji} ${row.label}`,
                value,
                fill: COLORS[i % COLORS.length],
            };
        });
        const chartData = base.filter((d) => d.value > 0);
        return { chartData, sumTotal: sum };
    }, [channelRows]);

    if (!channelRows?.length) return null;

    if (sumTotal <= 0) {
        return (
            <div className="rounded border bg-light p-3 h-100 d-flex align-items-center justify-content-center text-center text-muted small">
                Немає товарообігу з початку місяця для діаграми
            </div>
        );
    }

    return (
        <div className="rounded border bg-light p-3 w-100 h-100 d-flex flex-column">
            <div className="small fw-semibold text-body mb-2 text-center">
                Частка ТО за місяць (поточний факт)
            </div>
            <div className="flex-grow-1 d-flex justify-content-center align-items-center mb-0" style={{ minHeight: 0 }}>
                <div className="w-100 px-2" style={{ maxWidth: 340, height: 240 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={chartData}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                innerRadius={56}
                                outerRadius={88}
                                paddingAngle={2}
                                labelLine={false}
                                label={({ percent }) =>
                                    percent >= 0.04 ? `${Math.round(percent * 100)}%` : ""
                                }
                            >
                                {chartData.map((entry, i) => (
                                    <Cell
                                        key={entry.id || i}
                                        fill={entry.fill}
                                        stroke="#fff"
                                        strokeWidth={1}
                                    />
                                ))}
                            </Pie>
                            <Tooltip
                                formatter={(value, _name, item) => {
                                    const payload = item?.payload;
                                    const v = Number(value) || 0;
                                    const share =
                                        sumTotal > 0 ? ((v / sumTotal) * 100).toFixed(1) : "0";
                                    return [`${fmtUa(v)} грн (${share}%)`, payload?.name ?? ""];
                                }}
                            />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    );
}
